{
  "list": {
    "title": "Classes",
    "timetable": "Timetable",
    "list": "List",
    "addClass": "Add Class",
    "col": {
      "name": "Class",
      "teacher": "Teacher",
      "type": "Type",
      "level": "Level",
      "day": "Day",
      "time": "Time",
      "enrolled": "Enrolled"
    }
  },
  "form": {
    "heading": "Add Class",
    "name": "Name",
    "danceType": "Dance type",
    "danceTypePlaceholder": "Type…",
    "level": "Level",
    "levelPlaceholder": "Level…",
    "teacher": "Teacher",
    "teacherPlaceholder": "Teacher…",
    "day": "Day",
    "capacity": "Capacity (blank = unlimited)",
    "startTime": "Start time",
    "endTime": "End time",
    "create": "Create",
    "nameRequired": "Class name is required",
    "saveFailed": "Failed"
  },
  "detail": {
    "backToClasses": "Classes",
    "noTeacher": "No teacher",
    "day": "Day",
    "time": "Time",
    "capacity": "Capacity",
    "enrolled": "Enrolled",
    "unlimited": "Unlimited",
    "enrolledStudents": "Enrolled students",
    "addStudentPlaceholder": "Add student…",
    "enroll": "Enroll",
    "remove": "Remove",
    "noStudents": "No students enrolled",
    "upcomingSessions": "Upcoming sessions",
    "noSessions": "No sessions"
  },
  "toast": {
    "created": "Class created",
    "enrolled": "Enrolled"
  },
  "days": {
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "sunday": "Sunday"
  },
  "daysShort": {
    "monday": "Mon",
    "tuesday": "Tue",
    "wednesday": "Wed",
    "thursday": "Thu",
    "friday": "Fri",
    "saturday": "Sat",
    "sunday": "Sun"
  },
  "sessionStatus": {
    "scheduled": "Scheduled",
    "cancelled": "Cancelled",
    "completed": "Completed"
  }
}
